import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import { IBondLicense, ICreateBondLicenseRequest, IPage, IUpdateBondLicenseRequest } from '../interfaces/commercial.interface';

const headers = () => AuthService.getAuthHeader();

/**
 * Bond-warehouse license CRUD (T8, brief item 13.1). Mirrors `UdRegisterService`'s shape --
 * paged list, plain-object create/update payloads, headers() built per call.
 */
export const BondLicenseService = {
    list: async (institutionId: string, page = 0, size = 20): Promise<IPage<IBondLicense>> => {
        const res = await axios.get(ENDPOINTS.BOND_LICENSE.LIST(institutionId), { headers: headers(), params: { page, size } });
        return res.data;
    },

    get: async (institutionId: string, bondLicenseId: string): Promise<IBondLicense> =>
        (await axios.get(ENDPOINTS.BOND_LICENSE.GET(institutionId, bondLicenseId), { headers: headers() })).data,

    create: async (institutionId: string, request: ICreateBondLicenseRequest): Promise<IBondLicense> =>
        (await axios.post(ENDPOINTS.BOND_LICENSE.CREATE(institutionId), request, { headers: headers() })).data,

    update: async (institutionId: string, bondLicenseId: string, request: IUpdateBondLicenseRequest): Promise<IBondLicense> =>
        (await axios.put(ENDPOINTS.BOND_LICENSE.UPDATE(institutionId, bondLicenseId), request, { headers: headers() })).data,

    remove: async (institutionId: string, bondLicenseId: string): Promise<void> => {
        await axios.delete(ENDPOINTS.BOND_LICENSE.DELETE(institutionId, bondLicenseId), { headers: headers() });
    },
};
